export const multiStepResultTypes = {
  completed_registration: 'completed_registration',
  existing_registration: 'existing_registration',
  new_registration: 'new_registration',
  error: 'error',
};

// stepName is either 'step1', 'step2', etc. or 'email', or null for the entire object
export const getLocalStorageRegistrationInfo = (stepName = null) => {
  let registrationInfoRaw;
  try {
    registrationInfoRaw = localStorage.getItem('registration_info');

    if (!registrationInfoRaw) {
      return null;
    }
  } catch (error) {
    console.error('Error obtaining registration info from localStorage', error);
    return null;    
  }

  try {
    const registrationInfo = JSON.parse(registrationInfoRaw);
    return stepName?.length ? registrationInfo[stepName] : registrationInfo;
  } catch (error) {
    console.error('Error parsing registration info', error);
    return null;
  }
};

export const setLocalStorageRegistrationInfo = (stepName, info) => {
  const registrationInfo = getLocalStorageRegistrationInfo() || {};
  const newRegistrationInfo = {
    ...registrationInfo,
    [stepName]: info,
  };

  try {
    localStorage.setItem('registration_info', JSON.stringify(newRegistrationInfo));
    return true;
  } catch {
    return false;
  }
};

export const processMultiStepRegistrationEntry = (status, data, setEmailPending, setRegistrationComplete) => {
  if (status !== 200 || !data) {
    return { status: multiStepResultTypes.error };
  }

  const { step, status: resultStatus } = data;
  const stepNum = Number(step); // coerce to number
  if (!isNaN(stepNum)) {
    if (stepNum > 0) {
      return {
        status: multiStepResultTypes.new_registration,
        step: stepNum,
      };
    }

    setEmailPending(true);
    return { status: multiStepResultTypes.existing_registration };
  } if (resultStatus === 'completed_registration') {
    setRegistrationComplete(true);
    return { status: multiStepResultTypes.completed_registration };
  }
  return { status: multiStepResultTypes.error };
};
